import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineAtIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 2a10 10 0 1 0 5 18.66 1 1 0 1 0-1-1.73A8 8 0 1 1 20 12v.75a1.7503 1.7503 0 0 1-1.75 1.75 1.75 1.75 0 0 1-1.75-1.75V8.5a.9997.9997 0 0 0-1-1 .9999.9999 0 0 0-1 .79A4.45 4.45 0 0 0 12 7.5a4.5 4.5 0 1 0 3.3 7.5 3.7398 3.7398 0 0 0 4.1508 1.2596A3.7401 3.7401 0 0 0 22 12.75V12a9.9991 9.9991 0 0 0-2.9289-7.071A10.0001 10.0001 0 0 0 12 2Zm0 12.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"/>
  </SvgIcon>
}

export default LineAtIcon
